export default "__VITE_ASSET__C2u0zsfp__"